import { useQueryClient } from '@tanstack/react-query';

/**
 * Hook that provides a function to invalidate SMS-related queries
 * Call this after sending an SMS to ensure SMS history stays up-to-date
 */
export function useSMSQueryInvalidation() {
  const queryClient = useQueryClient();

  const invalidateSMSQueries = async () => {

    // Invalidate all SMS-related queries
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ['lead-sms-history'] }),
      queryClient.invalidateQueries({ queryKey: ['sms-history'] }),
      queryClient.invalidateQueries({ queryKey: ['communication', 'sms'] }),
      queryClient.invalidateQueries({ queryKey: ['dashboard-sms'] }),
    ]);

  };

  return { invalidateSMSQueries };
}
